var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5854 26.2083C8.22491 26.2083 6.04467 26.2083 4.69004 24.8537C3.81237 23.976 3.50334 22.7518 3.39453 20.8125H34.1095C34.0009 22.7518 33.6917 23.976 32.8141 24.8537C31.4594 26.2083 29.2792 26.2083 24.9187 26.2083H19.9083V32.375H24.9187C25.5573 32.375 26.075 32.8927 26.075 33.5312C26.075 34.1698 25.5573 34.6875 24.9187 34.6875H12.5854C11.9468 34.6875 11.4292 34.1698 11.4292 33.5312C11.4292 32.8927 11.9468 32.375 12.5854 32.375H17.5958V26.2083H12.5854Z",
    fill: "#E0B959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.6683 3.08337H21.835C27.6489 3.08337 30.556 3.08337 32.3621 4.88954C34.1683 6.69573 34.1683 9.60271 34.1683 15.4167V16.9584C34.1683 17.8088 34.1683 18.5762 34.1583 19.2709H3.34501C3.33496 18.5762 3.33496 17.8088 3.33496 16.9584V15.4167C3.33496 9.60271 3.33496 6.69573 5.14113 4.88954C6.94732 3.08337 9.8543 3.08337 15.6683 3.08337Z",
    fill: "#E0B959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesIcon);
export default __webpack_public_path__ + "static/media/ResourcesIcon.bba3bc40c9dd2e110ca8f5449d98af44.svg";
export { ForwardRef as ReactComponent };